import UploadDropzoneImage from '@/components/UploadDropzoneImage/UploadDropzoneImage';

export const UploadTab = ({
  setIsOpenLibraryModal,
  isOpenLibraryModal,
  setUploadFile,
}) => {
  return (
    <div>
      <UploadDropzoneImage
        setUploadImg={async (url) => {
          await setUploadFile(url);
          setIsOpenLibraryModal(!isOpenLibraryModal);
        }}
      />
    </div>
  );
};
